import { current } from "@reduxjs/toolkit";
import axios from "axios";
const transaction = process.env.REACT_APP_API_TRANSACTION;

const currentUser = JSON.parse(sessionStorage.getItem('authUser'));

export const getBusinessAccount = async ({ queryKey }) => {
    const [, userId, token] = queryKey;
    const response = await axios.get(process.env.REACT_APP_API_URL + '/developer-accounts/merchant/' + userId, {
        headers: {
            "Authorization": `Bearer ${token}`
        }
    });

    return response;
}

export const getCollectLink = async ({ selectedBusiness, token }) => {

    const response = await axios.get(
        `${transaction}/manage/collect-link/business`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                business: selectedBusiness?.id
            }
        }
    );
    return response.data;
}

export const getCollectLinkTransactions = async ({ queryKey }) => {
    const [, linkId, businessId, token] = queryKey;
    const response = await axios.get(
        `${transaction}/manage/collect-link/transactions/${linkId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params: {
                business: businessId
            }
        }
    );
    return response.data;
}

// export const getPaymentLinkOld = async ({ queryKey }) => {
//     const [_key, businessAccountSelected, token] = queryKey;
//     console.log(token);
//     console.log(localStorage.getItem('businessId'));
//     const response = await axios.get(
//         `${process.env.REACT_APP_API_TRANSACTION}/subscriptions/developer/${localStorage.getItem('businessId')}`,
//         {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 'x-api-key': localStorage.getItem('businessApiKey'),
//                     'X-API-TOKEN': localStorage.getItem('businessApiToken'),
//             },
//         }
//     );

//     console.log(response);
//     return response;
// }

export const getContactInfo = async ({ queryKey }) => {
    const [_key, merchantId, token] = queryKey;
    const response = await axios.get(
        `${process.env.REACT_APP_API_TRANSACTION}/subscriptions/clients-infos/${merchantId}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
                'x-api-key': localStorage.getItem('businessApiKey'),
                'X-API-TOKEN': localStorage.getItem('businessApiToken'),
            },
        }
    );
    return response;
}

export const createCollectLink = (data) => {
    const response = axios.post(transaction + '/manage/collect-link/create', data, {
        headers: {
            "Authorization": `Bearer ${data?.token}`,
        },
        params: {
            merchant: data?.userId,
            business: data?.businessId
        }
    });
    return response;
}

export const deleteLinkPayment = (requestData) => {
    const response = axios.delete(process.env.REACT_APP_API_TRANSACTION + `/manage/collect-link/${requestData.id}`, {
        headers: {
            "Authorization": `Bearer ${requestData.token}`,
        },
        params: {
            business: requestData?.business
        }
    });
    return response;
}

export const suspendLinkPayment = (requestData) => {
    const response = axios.put(process.env.REACT_APP_API_TRANSACTION + `/subscriptions/suspend/${requestData.id}`, {
        headers: {
            "Authorization": `Bearer ${requestData.token}`
        }
    });
    return response;
}